import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectIsAuth, selectUser } from "./auth.selector";
import { Outlet } from "react-router-dom";
import { checkPathAccess } from "../../redux/reducers/sidebar";

const PrivateRoute = ({ path }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const userInfoData = useSelector(selectUser);
  const isAuthenticatedRedux = useSelector(selectIsAuth);

  const { isPathAuthorized } = useSelector((state) => state.sidebar);

  useEffect(() => {
    if (isAuthenticatedRedux && userInfoData) {
      dispatch(
        checkPathAccess({
          userId: userInfoData?.uid || userInfoData?.user_id || "",
          token: userInfoData?.token,
          path,
        })
      );
    }
  }, [isAuthenticatedRedux]);

  if (!isAuthenticatedRedux) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (isPathAuthorized === false) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
